import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { logoutEverywhere } from "../../utils/api";

const LogoutEverywhereButton = ({
  variant = "contained",
  size = "medium",
  fullWidth = false,
}) => {
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleOpen = () => {
    setErrorMessage("");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogoutEverywhere = async () => {
    try {
      const revokedEverywhere = await logoutEverywhere();
      if (revokedEverywhere) {
        window.location = "https://exacc.au/";
        return;
      }
      setErrorMessage(
        "Your local session was cleared, but other sessions could not be revoked. Please try again.",
      );
    } catch {
      setErrorMessage(
        "Your local session was cleared, but other sessions could not be revoked. Please try again.",
      );
    }
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        onClick={handleOpen}
        color="error"
        data-testid="logout-everywhere-button--Button-0">
        Log me out from everywhere
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        data-testid="logout-everywhere-button--Dialog-0">
        <DialogContent data-testid="logout-everywhere-button--DialogContent-0">
          <Typography>
            All your sessions will be terminated and you will have to log in on
            all your devices, including this one. Continue?
          </Typography>
          {errorMessage && (
            <Typography color="error" sx={{ mt: 2 }} role="alert">
              {errorMessage}
            </Typography>
          )}
        </DialogContent>
        <DialogActions data-testid="logout-everywhere-button--DialogActions-0">
          <Button onClick={handleClose} data-testid="logout-everywhere-button--Button-1">Cancel</Button>
          <Button
            onClick={handleLogoutEverywhere}
            color="error"
            variant="contained"
            data-testid="logout-everywhere-button--Button-2">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LogoutEverywhereButton;
